import React from 'react'
import PropTypes from 'prop-types'
import {Button, Flex, Box, useMultiStyleConfig} from '@chakra-ui/react'
import {Link as RouteLink} from 'react-router-dom'
import useDamImage from '../../../custom-hooks/use-dam-image'
import SanitizedHtml from '../../html-sanitizer'

const KeyFeaturesCardEditorial = ({
    imageUrl,
    images,
    title,
    description,
    linkLabel,
    linkUrl,
    isSlider,
    isLinkAbsolute = false,
}) => {
    const styles = useMultiStyleConfig('KeyFeatures', {
        variant: isSlider ? 'slider' : 'default',
    })

    const damImage = useDamImage(images)

    const imageToUse = damImage.url || imageUrl

    const buttonProps = isLinkAbsolute
        ? {
              as: 'a',
              href: linkUrl,
              target: '_blank',
              rel: 'noopener noreferrer',
          }
        : {
              as: RouteLink,
              to: linkUrl,
          }

    return (
        <Flex
            {...styles.card}
            flexDirection="column"
            backgroundImage={imageToUse ? `url(${imageToUse})` : undefined}
            backgroundSize="cover"
            backgroundPosition="center"
            backgroundRepeat="no-repeat"
        >
            <Flex flex={1} />
            <Flex {...styles.cardContent} flexDirection="column" position="relative">
                <Box {...styles.blur} />
                <SanitizedHtml as={Box} html={title} {...styles.cardTitle} />
                <SanitizedHtml
                    as={Box}
                    html={description}
                    {...styles.cardDescription}
                    color="foreground.neutral.inverse"
                />
            </Flex>
            {linkUrl && linkLabel && (
                <Button
                    {...buttonProps}
                    variant="primary"
                    {...styles.cardButton}
                    data-testid="key-features-card-button"
                >
                    {linkLabel}
                </Button>
            )}
        </Flex>
    )
}

KeyFeaturesCardEditorial.propTypes = {
    isLinkAbsolute: PropTypes.bool,
    imageUrl: PropTypes.string,
    images: PropTypes.object,
    title: PropTypes.string,
    description: PropTypes.string,
    linkLabel: PropTypes.string,
    linkUrl: PropTypes.string,
    isSlider: PropTypes.bool,
    aspectRatio: PropTypes.string,
}

export default KeyFeaturesCardEditorial
